<template>
    <div class="register">
        <div :class="`step_head ${registre_step == 2 ? 'step_head_2' : ''}`">
            <div v-for="i in 3" :key="i" :class="`step_head_item ${i <= registre_step ? 'active' : ''}`"></div>
        </div>

        <!-- Step 1 -->
        <div :class="`step step_1 ${registre_step == 1 ? 'active' : ''}`">
            <div class="title">{{text('auth.register.title')}}</div>
            <div class="inputs">
                <Input type="text" v-model:value="user.first_name" :placeholder="text('auth.register.first_name')" />
                <Input type="text" v-model:value="user.last_name" :placeholder="text('auth.register.last_name')" />
                <Input type="email" v-model:value="user.email" :placeholder="text('auth.register.email')" />
                <InputMask v-model:phone="user.phone" />
            </div>

            <Button 
                @btnClick="register()"  
                :title="text('auth.register.continue_btn')" 
                :disabled="!ofertaAccepted || !persDataAccepted || user.first_name.length === 0 || user.last_name === 0 || user.email.length === 0" 
            />
            <div class="error">{{ errorMessage }}</div>

            <div class="text"> 
                <a href="/auth/login">{{text('auth.register.enter_help')}}</a>
            </div>
            <br />      
            <br />             

            <StaterAccept 
              v-if="envName === 'stater'" 
              v-model:ofertaAccepted="ofertaAccepted"
              v-model:persDataAccepted="persDataAccepted"
            />         
        </div>
        <!-- End steop 1 -->

        <!-- Step 1 -->
        <div :class="`step step_2 ${registre_step == 2 ? 'active' : ''}`">
            <AuthIdentification 
                v-model:confirmCode="confirmCode" 
                :phone="user.phone" 
                @onPrevPage="changeToPrevPage" 
                :title="text('auth.register.enter_code_help')" 
                :description="text('auth.register.enter_code_descr')"
            />
            <div class="error">{{ errorMessage }}</div>
            
            <div style="margin: 0 24px;" class="text" v-if="envName === 'stater'"> 
                <br />
                <br />
                Не приходит код? <br />
                Обратитесь в службу поддержки: <br />
                <br />
                <b>+7 (940) 999-11-33</b>    
                <br /> 
            </div>

            <Button 
                @btnClick="phoneConfirm()" 
                :disabled="confirmCode.length < 4" 
                :title="text('auth.register.continue_btn')"
            />
            <send-again-button @btnClick="sendCode()"  :title="text('auth.register.send_again_btn')"/>

        </div>
        <!-- End steop 1 -->

        <!-- Step 1 -->
        <div :class="`step step_3 ${registre_step == 3 ? 'active' : ''}`">
            <AuthIdentification 
                v-model:confirmCode="pinCode" 
                :prevButton="false"
                :title="text('auth.register.set_pin.help')" 
                :description="text('auth.register.set_pin.descr')"
            />
            <Button 
                @btnClick="savePinCode()"
                :disabled="pinCode.length < 4" 
                :title="text('auth.register.set_pin.continue')"
            />
        </div>
        <!-- End steop 1 -->

        <GrokPolicy v-if="envName === 'grok'" />

    </div>
</template>

<script>

import Input from "@/components/Input.vue"
import InputMask from "@/components/phone_input/InputMask.vue"
import Button from "@/components/Button.vue"
import AuthIdentification from '@/components/AuthIdentification.vue'
import SendAgainButton from '@/components/SendAgainButton.vue'
import { doRegister, doRegisterPhoneConfirm, doRegisterSetPin } from "@/services/api"
import StaterAccept from '@/components/StaterAccept.vue'
import GrokPolicy from '@/components/GrokPolicy.vue'

export default{
    name: "Register",
    components: { 
        Input,
        InputMask,
        Button,
        AuthIdentification,
        SendAgainButton,    
        StaterAccept,
        GrokPolicy
    }, 
    computed: {
        authToken () {
            return this.$store.state.authToken
        }
    },
    data () {
        return {
            registre_step: 1,
            user: {
                first_name: '',
                last_name: '',
                email: '',
                phone: ''
            },
            confirmCode: '',
            pinCode: '',
            errorMessage: '',
            ofertaAccepted: true,
            persDataAccepted: true,
        }
    },
    methods: {
        async sendCode() {
            const { data } = await this.$http.post(
                '/v2/wallet/auth/send_code',
                { "phone": this.phone }
            );
        },
        async register () {
            this.pinCode = '';

            const resp = await doRegister(this.user.first_name, this.user.last_name, this.user.phone, this.user.email)
            if (resp.status === "error") {
                this.errorMessage = resp.message;
            } else {
                this.errorMessage = '';
                this.registre_step = 2;
            }
        },
        async savePinCode () {
            await doRegisterSetPin(this.authToken, this.pinCode)
            this.$router.push('/')
        },
        changeToPrevPage () {
            this.registre_step = 1;
        },
        async phoneConfirm () {
            const resp = await doRegisterPhoneConfirm(this.user.phone, this.confirmCode)
            if (resp.status === "error") {
                this.errorMessage = resp.message;
            } else {            
                this.errorMessage = '';
                this.$store.commit('setAuthToken', resp.auth_token)
                this.registre_step = 3
            }
        }
    }
}
</script>

<style>

</style>